import { createContext } from "react";
import { initialIntegrationObj, IIntegration } from "./integration.interface";

export const IntegrationContext = createContext<{
    integration: IIntegration,
    setIntegration: (integration: IIntegration) => void,
    demandWLTemplates?: Record<string, string>,
    setDemandWLTemplates: (demandWLTemplates: Record<string, string>) => void,
}>({
    integration: initialIntegrationObj,
    setIntegration: () => {},
    demandWLTemplates: {},
    setDemandWLTemplates: () => {},
});